import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const EntitlementsIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M15 12h-5" />
      <path d="M15 8h-5" />
      <path d="M19 17V5a2 2 0 0 0-2-2H4" />
      <path d="M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3" />
    </BaseIcon>
  );
};

EntitlementsIcon.displayName = 'EntitlementsIcon';
